import React, { useEffect, useState } from 'react';

import { Action, CollectionServer, DropdownAction, GET, JSXMap, QueryOrder, errorCatch, useCollectionRef } from 'fennec-ui'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import User from '../../../common/User';
import RassilkaText from '../RassilkaText';
import { Button, Select } from 'antd';
import RassilkaSourceText from '../RassilkaSourceText';
dayjs.locale('ru');

const { Option } = Select;


function KomuOtpravlenoRow({ auth, item, idx, rassilka, setCollectionItem, modelActions, collection, setCollection }) {
    // const [collapsed, setCollapsed] = useState(true);

    const rowColor = (false) ? "bg-red" : "bg-grey";
    return (<React.Fragment key={idx}>
        <tr key={idx}>
            {/* <td className={`fill`}><div className={`bg ${rowColor}`} style={{ minWidth: "25px", maxWidth: "25px" }}>
                {(collapsed) && <i className="fa fa-plus-square-o"></i>}
                {(!collapsed) && <i className="fa fa-minus-square-o"></i>}
            </div></td> */}

            <td className={`fill`}>
                {/* <div className={`bg bg-${(item?.neUchastvuetVReitinge) ? "red dark-1" : "grey"}`}>
                    ({item?.kategoriyaUchastnikov?.tantsevalnayaDistsiplinaID}) {item?.kategoriyaUchastnikov?.tantsevalnayaDistsiplina?.nazvanie}
                </div> */}
                <div>
                    <User item={item?.polzovatel} noborder={true} />
                </div>
            </td>
            <td className={`fill`}>
                <div className={`bg bg-${(item?.uchastnik?.genderID === 1) ? "blue" : "red"}`}>
                    {!!item?.vk && <i className="fa fa-check"></i>}
                </div>
            </td>
            <td className={`fill`}>
                <div className={`bg bg-${(item?.uchastnik?.genderID === 1) ? "blue" : "red"}`}>
                    {!!item?.max && <i className="fa fa-check"></i>}
                </div>
            </td>
            <td className={`fill`}>
                <div className={`bg bg-${(item?.neUchastvuetVReitinge) ? "red dark-1" : "grey"}`}>
                    {!!item?.tg && <i className="fa fa-check"></i>}
                </div>
            </td>
            <td className={`fill`}>
                <div className={`bg bg-${(item?.neUchastvuetVReitinge) ? "red dark-1" : "grey"}`}>
                    {!!item?.email && <i className="fa fa-check"></i>}
                </div>
            </td>
            <td className={`fill`} onClick={(e) => { e.stopPropagation() }}>
                <DropdownAction
                    style={{ padding: "0" }}
                    button={() => (<div className={`bg ${rowColor} pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                        <i className="fa fa-ellipsis-h"></i>
                    </div>)}
                    items={modelActions(item, idx)?.map((e, idx) => ({
                        key: e.key || idx,
                        auth: auth,
                        mode: "MenuItem",
                        object: item,
                        collection: collection,
                        setCollection: setCollection,
                        ...e
                    }))} />
            </td>
        </tr>
        {/* {(!collapsed) && <tr>
            <td colSpan={5} className={`fill`}>
                <div className="bg bg-orange" style={{ textAlign: "left", marginLeft: "25px" }}>

                </div>
            </td>
        </tr>} */}
    </React.Fragment>)
}
function CustomBool({ item, value, onChange, onAfterChange }) {
    const valueToSelect = (value) => {
        if (value === true) {
            return 1
        } else if (value === false) {
            return 2
        }
        return
    }
    return (
        <Select showSearch
            size={(item.size) ? item.size : "middle"}
            value={valueToSelect(value)}
            onChange={e => {
                if (e === 1) {
                    onChange(true, item, undefined)
                } else if (e === 2) {
                    onChange(false, item, undefined)
                } else {
                    onChange(undefined, item, undefined)
                }
            }}
            style={{ width: "100%" }}
            allowClear={true}
            disabled={(item && item.view && item.view.disabled) ? item.view.disabled : false}
            filterOption={(input, element) =>
                element.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            <Option key={1} value={1}>Да</Option>
            <Option key={2} value={2}>Нет</Option>
        </Select>
    )
}
export default function RassilkaInfo(props) {
    const { auth, object } = props;
    const [info, setInfo] = useState();

    useEffect(() => {
        GET(auth, `/api/rassilka/get/${object.ID}`,
            ({ data }) => {
                setInfo(data)
            },
            errorCatch);
    }, [object])
    const cref = useCollectionRef()
    const filters = () => [
        {
            name: "polzovatel.lastname",
            sort: true,
            filter: true,
        },
        {
            name: "polzovatel.firstname",
            sort: true,
            filter: true,
        },
        {
            name: "polzovatel.gender",
            display: (o) => o.name,
            queryFilter: [
                QueryOrder("name", "ASC"),
            ],
            sort: true,
            filter: true,
        },
        {
            name: "max",
            type: "func",
            permanent: true,
            render: (auth, item, value, onChange, onAfterChange) => {
                return (<CustomBool auth={auth} item={item} value={value} onChange={onChange} onAfterChange={onAfterChange}></CustomBool>)
            },
            sort: true,
            filter: true,
        },
        {
            name: "tg",
            type: "func",
            permanent: true,
            render: (auth, item, value, onChange, onAfterChange) => {
                return (<CustomBool auth={auth} item={item} value={value} onChange={onChange} onAfterChange={onAfterChange}></CustomBool>)
            },
            sort: true,
            filter: true,
        },
        {
            name: "vk",
            type: "func",
            permanent: true,
            render: (auth, item, value, onChange, onAfterChange) => {
                return (<CustomBool auth={auth} item={item} value={value} onChange={onChange} onAfterChange={onAfterChange}></CustomBool>)
            },
            sort: true,
            filter: true,
        },
        {
            name: "email",
            type: "func",
            permanent: true,
            render: (auth, item, value, onChange, onAfterChange) => {
                return (<CustomBool auth={auth} item={item} value={value} onChange={onChange} onAfterChange={onAfterChange}></CustomBool>)
            },
            sort: true,
            filter: true,
        },
        // {
        //     label: "Дисциплина",
        //     name: "kategoriyaUchastnikov.tantsevalnayaDistsiplina",
        //     filterType: "group",
        //     display: (o) => o.nazvanie,
        //     queryFilter: [
        //         QueryOrder("nazvanie", "ASC"),
        //     ],
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: "Категория",
        //     name: "kategoriyaUchastnikov.kategoriyaUchastnikov",
        //     filterType: "group",
        //     display: (o) => o.nazvanie,
        //     queryFilter: [
        //         QueryOrder("nazvanie", "ASC"),
        //     ],
        //     sort: true,
        //     filter: true,
        // },
    ];
    return (
        <div>
            <div>
                <Action
                    auth={auth}
                    mode={"func"}
                    trigger={(click) => (
                        <div>
                            <Button onClick={click}>Исходный текст</Button>
                        </div>
                    )}
                    title="Исходный текст рассылки"
                    readonly={true}
                    noAntForm={true}
                    modal={{
                        width: "940px",
                    }}
                    object={object}
                    form={RassilkaSourceText}
                    action={(values, unlock, close, { collection, setCollection }) => { if (close) close(); }}
                />
            </div>
            <CollectionServer
                auth={auth}
                name={"KomuOtpravleno"}
                source={`/api/rassilka/get/${object.ID}/komu-otpravleno`}
                // contextFilters={() => [
                //     QueryOrder("isAdmin", "DESC")
                // ]}
                collectionRef={cref}
                filters={filters}
                customRender={(items, {
                    collection,
                    setCollection,
                    setCollectionItem,
                    removeCollectionItem,
                    collectionActions,
                    modelActions,
                    update
                }) => (
                    <div className='scrollable'>
                        <table className="table" style={{ fontSize: "13px" }}>
                            <thead>
                                <tr>
                                    <th className={`wrap`} style={{ minWidth: "120px", maxWidth: "120px" }}><div className='bg bg-grey dark-1'>Пользователь</div></th>
                                    <th className={`wrap`} style={{ minWidth: "70px", maxWidth: "70px", width: "70px" }}>ВКонтакте</th>
                                    <th className={`wrap`} style={{ minWidth: "70px", maxWidth: "70px", width: "70px" }}>Max</th>
                                    <th className={`wrap`} style={{ minWidth: "70px", maxWidth: "70px", width: "70px" }}>Телеграм</th>
                                    <th className={`wrap`} style={{ minWidth: "70px", maxWidth: "70px", width: "70px" }}>Почта</th>
                                    <th className={`wrap`} style={{ minWidth: "25px", maxWidth: "25px", width: "25px" }}></th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px" }}>
                                {JSXMap(items, (o, oidx) => {
                                    return (<KomuOtpravlenoRow key={oidx} auth={auth} item={o} idx={oidx} rassilka={object} collection={collection} setCollection={setCollection} setCollectionItem={setCollectionItem} modelActions={modelActions} />)
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
                size={"small"}
                modelActions={(item) => [{
                    title: "Текст TG",
                    mode: "MenuItem",
                    auth: auth,
                    object: item,
                    system: "tg",
                    form: RassilkaText,
                    readonly: true,
                    noAntForm: true,
                    modal: {
                        width: "660px"
                    },
                    action: (values, unlock, close) => {
                    }
                },
                {
                    title: "Текст VK",
                    mode: "MenuItem",
                    auth: auth,
                    object: item,
                    system: "vk",
                    form: RassilkaText,
                    readonly: true,
                    noAntForm: true,
                    modal: {
                        width: "660px"
                    },
                    action: (values, unlock, close) => {
                    }
                }]}
            />
        </div>

    );
}
